export default "__VITE_ASSET__DkDG_XUV__"